module.exports = __webpack_public_path__ + "images/emoji/clock930.6955159e46fd7e15c90d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock930.png
// module id = WnN+
// module chunks = 13